import { render, staticRenderFns } from "./grouPayType.vue?vue&type=template&id=3af6164f&scoped=true&"
import script from "./grouPayType.vue?vue&type=script&lang=js&"
export * from "./grouPayType.vue?vue&type=script&lang=js&"
import style0 from "./grouPayType.vue?vue&type=style&index=0&id=3af6164f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af6164f",
  null
  
)

export default component.exports